<template>
  <div class="l-container h-full confirm-info mx-auto">
    <div class="top-title">
      <h3>お申し込みキャンセル（キャンセル確認）</h3>
    </div>
    <div class="mt-6 mb-6 divider border"></div>
    <div class="main-content flex">
      <div class="left-content mx-4 ml-0">
        <LeftMenuBar v-bind:nav-bars="navBars" />
      </div>
      <div class="right-content">
        <div class="meta-item-back mx-4">
          <i class="icon icon-bor-arrow-left" />
          <a class="text-black" @click="handleBack()">お申し込み情報詳細に戻る</a>
        </div>
        <div class="c-box m-4 mr-0">
          <div class="mx-6">
            <div class="main-top flex flex-wrap">
              <div class="main-top-left">
                <div class="item" v-if="acptDatetime">
                  <span class="date-time">申込日：{{ acptDatetime }}</span>
                </div>
                <div class="item">
                  <span class="date-time">受付番号：{{ acptNo }}</span>
                </div>
              </div>
              <div class="main-top-right" v-if="reserveSts === '3'">
                <div class="label label-grey-200">手配状況：キャンセル済み</div>
              </div>
              <div class="main-top-right" v-if="reserveSts !== '3'">
                <div class="label label-grey-200">手配状況：成立 手配完了</div>
                <div class="label label-grey-200" v-if="statusOrder">
                  {{ statusOrder }}
                </div>
              </div>
            </div>
            <Item :data="dataItem" />
            <div class="pt-3">
              <SectionContentTitle
                :lineType="lineType.vertical"
                :titleContent="titleContent[0]"
              />
              <div class="box-content" v-if="planNm">
                <p
                  class="two-lines-ellipsis"
                  v-html="planNm.replaceAll('\n', '<br>')"
                ></p>
              </div>
            </div>
            <div class="pt-3">
              <SectionContentTitle
                :lineType="lineType.vertical"
                :titleContent="titleContent[1]"
              />
              <div class="box-content">
                <div class="style-div">
                  <span class="title">宿泊期間</span>
                  <span class="results">
                    {{ useDate }}
                    <span class="ml-0" v-if="useDate && endDate">〜 </span>
                    {{ endDate }}
                  </span>
                </div>
                <div class="style-div">
                  <span class="title">宿泊代表者名</span>
                  <span class="results" wovn-ignore> {{ fullName }}</span>
                </div>
                <div class="style-div">
                  <span class="title">部屋数</span>
                  <span class="results">{{ roomCount }}</span>
                </div>
              </div>
            </div>
            <div class="pt-3">
              <SectionContentTitle
                :lineType="lineType.vertical"
                :titleContent="titleContent[2]"
              />
              <div class="box-content">
                <div class="style-div">
                  <span class="title">宿泊代金</span>
                  <span class="results" v-if="totalAmt">{{
                    totalAmt | formatCurrency
                  }}</span>
                  <span class="results" v-if="totalAmt === 0">0 円</span>
                </div>
              </div>
            </div>
            <span class="text-label">＜補助金・ポイント利用＞</span>
            <div class="mt-4">
              <div class="box-content">
                <div class="style-div">
                  <span class="title">企業補助金利用額</span>
                  <span class="discount-price" v-if="sbsidTotal"
                    >- {{ sbsidTotal | formatCurrency }}</span
                  >
                  <span class="discount-price" v-if="sbsidTotal === 0">- 0 円</span>
                </div>
                <div class="style-div">
                  <span class="title">ベネポ利用額</span>
                  <span class="results" v-if="pointUse"
                    >- {{ pointUse | formatInteger }} ポイント（円）</span
                  >
                  <span class="results" v-if="pointUse === 0">0 ポイント（円）</span>
                </div>
              </div>
            </div>
            <div class="divider"></div>
            <div class="box-content flex gap-3 mt-4">
              <div class="style-div">
                <span class="title">支払金額</span>
                <span class="results" v-if="billAmtTotal">{{
                  billAmtTotal | formatCurrency
                }}</span>
                <span class="results" v-if="billAmtTotal === 0">0 円</span>
              </div>
            </div>
            <div>
              <div class="menu-price flex">
                <div class="text-primary font-text">
                  キャンセルポリシーをご確認ください。
                </div>
                <!-- <div class="text-primary font-text">
                  こちらのお申し込みはキャンセル料が発生します。
                </div> -->
                <!-- <div class="price-content">
                  <span class="text-gray-500 mr-2 font-text"
                    >キャンセル料金</span
                  >
                  <strong>20,000円</strong>
                </div> -->
                <div class="text-primary font-text">
                  <span class="text-black pr-3">キャンセル料金</span>
                  <span class="font-bold">{{ cancelAmt | formatInteger }} 円</span>
                </div>
              </div>
            </div>
          </div>
          <div class="divider mt-8"></div>
          <div class="mx-6 pt-8">
            <SectionContentTitle
              :lineType="lineType.vertical"
              titleContent="キャンセル規定"
            />
            <div class="">
              <div v-for="(item, index) in cancelPolicies" :key="index">
                <div class="box-content">
                  <h2 class="mb-2">{{ item.cancelTitle }}</h2>
                  <div
                    class="results"
                    v-if="item && item.cancelNote1"
                    v-html="item.cancelNote1.replaceAll('\n', '<br>')"
                  ></div>
                  <div
                    class="results"
                    v-if="item && item.cancelNote2"
                    v-html="item.cancelNote2.replaceAll('\n', '<br>')"
                  ></div>
                  <table class="table-common">
                    <tr
                      v-if="item.cancelPolicyTable && item.cancelPolicyTable.length > 0"
                    >
                      <th class="t-left">お支払情報</th>
                      <th class="style-t t-right">規定率</th>
                    </tr>
                    <tr v-for="(val, index) in item.cancelPolicyTable" :key="index">
                      <td>{{ val.cancelRule }}</td>
                      <td class="style-t">{{ val.cancelCond }}</td>
                    </tr>
                  </table>
                  <!-- <h2 class="font-bold">団体キャンセル規定（15名以上）</h2>
                  <table class="table-common">
                    <tr>
                      <th class="t-left">キャンセル日</th>
                      <th class="style-t t-right">規定率</th>
                    </tr>
                    <tr>
                      <td>11/15～11/15まで</td>
                      <td class="style-t">料金の20％</td>
                    </tr>
                    <tr>
                      <td>11/15～11/15まで</td>
                      <td class="style-t">料金の20％</td>
                    </tr>
                    <tr>
                      <td class="style-c">11/15～11/15まで</td>
                      <td class="style-t">料金の20％</td>
                    </tr>
                  </table> -->
                  <!-- <h2 class="font-bold">キャンセルについての補足</h2>
                  <div v-for="(item, index) in cancelPolicies" :key="index">
                    <ul>
                      <li class="results">
                        {{ item.cancelNote1 }}
                      </li>
                      <li class="results">
                       {{ item.cancelNote2 }}
                      </li>
                    </ul>
                 </div> -->
                </div>
              </div>
              <h2 class="font-bold pb-3">キャンセルについての補足</h2>
              <div v-for="(item, index) in cancelPolicies" :key="index">
                <ul>
                  <li class="results pl-1">
                    ・
                    <span
                      v-if="item && item.cancelNote1"
                      v-html="item.cancelNote1.replaceAll('\n', '<br>')"
                    >
                    </span>
                  </li>
                  <li class="results pl-1">
                    ・
                    <span
                      v-if="item && item.cancelNote2"
                      v-html="item.cancelNote2.replaceAll('\n', '<br>')"
                    >
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="divider mt-10"></div>
          <div class="pt-8 pb-10 w-full text-center">
            <div class="bottom-content mb-2">
              <div>
                <a-checkbox @change="onChange">
                  キャンセル規定を確認しました。</a-checkbox
                >
              </div>
            </div>
            <button class="c-btn btn-grey">
              <span class="pr-16 pl-16" @click="handleNext()">支払方法を選択する</span>
            </button>
          </div>
        </div>
        <div class="meta-item-back ml-4">
          <i class="icon icon-bor-arrow-left" />
          <a class="text-black" @click="handleBack()">お申し込み情報詳細に戻る</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LeftMenuBar, Item, SectionContentTitle } from '@/components/compound'
import {
  GET_ORDER_DETAIL,
  SAVE_DATA_BS_MYP_05_040,
  SAVE_CANCEL_NO
} from '@/store/modules/order/actions.js'
import { GET_MENU_INFO } from '@/store/modules/menu_info/actions'
import { CANCEL_ORDER } from '@/store/modules/plan/actions'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'BS_MYP_05_040',
  components: {
    LeftMenuBar,
    Item,
    SectionContentTitle
  },
  data() {
    return {
      acptNo: null,
      acptDtlNo: '',
      acptDatetime: null,
      planNm: null,
      roomCount: null,
      totalAmt: null,
      sbsidTotal: null,
      boneSbsidChrgTotal: null,
      pointUse: null,
      billAmtTotal: null,
      cancelPolicies: {},
      confirmCheckbox: false,
      errorMessageNext: 'キャンセル規定確認のチェックボックスを選択してください',
      facilityTelNo: null,
      pointGrntNumAmt: null,
      planDetail: null,
      cancelPolicy: null,
      menuNo: null,
      planId: null,
      roomId: null,
      useDate: '',
      endDate: '',
      nightCnt: '',
      rpsntFamilyNmKana: '',
      rpsntFirstNmKana: '',
      resrvFamilyNmKana: '',
      resrvFirstNmKana: '',
      fullName: '',
      dataOrderInfo: {},
      dataOrderDetail: {},
      planBasicInfo: {},
      roomBasicInfo: {},
      reserveSts: '',
      statusOrder: '',
      orderDetail: {},
      menuNm: '',
      cancelChrgRate: null,
      cancelAmt: 0,
      cancelCharge: null,
      navBars: [
        { path: '/mypage', name: 'マイページトップ' },
        { type: 'divider' },
        { path: '/mypage/benepo-history', name: '総保有ベネポ・ベネポ履歴' },
        { path: '/mypage/benepo-collect', name: '獲得予定のベネポ' },
        { type: 'divider' },
        { path: '/mypage/coupons', name: '専用ポイント・補助クーポン' },
        { type: 'divider' },
        { path: 'bs-myp-02-001', name: 'マイクーポン' },
        { path: 'bs-myp-02-010', name: '過去のクーポン' },
        { type: 'divider' },
        { path: '/mypage/orders', name: 'お申し込み履歴' },
        { path: '', name: '給トク払いご利用履歴', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '/mypage/visits', name: '閲覧履歴' },
        { type: 'divider' },
        { path: '/mypage/favorites', name: 'お気に入りメニュー' },
        { type: 'divider' },
        { path: '/mypage/setting', name: '会員プロフィール', icon: 'icon-bor-copy' },
        { path: '', name: 'メール受信・通知', icon: 'icon-bor-copy' },
        { path: '', name: 'クレジットカード', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '家族アカウント管理', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: 'ログアウト', icon: 'icon icon-bor-logout' }
      ],
      titleContent: ['プラン名', 'ご宿泊期間', 'お支払い情報', 'キャンセル規定'],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      breadcrumb_data: [
        'トップ',
        'マイページ',
        'お申し込み一覧',
        'お申し込み情報詳細',
        'お申し込みキャンセル（キャンセル確認）'
      ],
      dataItem: {
        baseImg: null,
        type: 'type-small-1',
        label: '',
        icon: 'icon icon-bor-phone-call',
        menu_id: '',
        title3: '',
        phone: '',
        text: '',
        pointGrntNumAmt: ''
      },
      // ---------------------->
      feeCancel: 10,
      cancelChrDiv: null,
      memberChrgTotalAll: 0,
      memberChrgTotal: 0,
      tieupChrgTotalAll: 0,
      boneSbsidChrgTotalAll: 0,
      payMethod: '10',
      useHeadCnt: 1,
      cancelChrgUnit: 0,
      stayPlanCancelPrticKey: null,
      stayCancelAcptPrticList: [],
      dataOrder: null
    }
  },
  watch: {
    dataItem: {
      value: {
        deep: true,
        handler() {}
      }
    }
  },
  mounted() {
    if (this.loggedIn) {
      this.getOrderInfo()
      this.getPlanBasicInfo()
    } else {
      const params = {
        loggin: 1
      }
      this.$router.push({ path: '/', query: params })
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    },
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    },
    getOrder() {
      return this.$store.getters.getOrder
    },
    getOrderInfo2() {
      return _.cloneDeep(_.get(this.$store.state, 'order_old.bs_myp_05_040', null))
    }
  },
  methods: {
    onChange($event) {
      this.confirmCheckbox = $event.target.checked
    },
    getOrderInfo() {
      const { acptNo } = this.$route.query
      this.acptNo = acptNo
      this.$store.dispatch(GET_ORDER_DETAIL, acptNo).then((response) => {
        if (response !== null) {
          this.orderDetail = response
          this.getCancelAmt()
          this.menuNo = _.get(
            response,
            'orderStayDetail.acptDtlList[0].acptDtl.menuNo',
            ''
          )
          this.planId = _.get(
            response,
            'orderStayDetail.acptDtlList[0].acptDtl.planId',
            ''
          )
          this.roomId = _.get(
            response,
            'orderStayDetail.acptDtlList[0].acptPrticList[0].stayRoomDayPrticList[0].stayRoomDayPrtic.roomId',
            ''
          )
          this.useDate = moment(
            _.get(response, 'orderStayDetail.acptDtlList[0].acptDtl.useDate', '')
          ).format('YYYY/MM/DD')
          const date = new Date(this.useDate)
          this.nightCnt = _.get(
            response,
            'orderStayDetail.acptDtlList[0].stayAcptDtl.nightCnt',
            0
          )
          date.setDate(date.getDate() + this.nightCnt)
          this.endDate = moment(date).format('YYYY/MM/DD')
          this.reserveSts = _.get(
            response,
            'orderStayDetail.acptDtlList[0].stayAcptDtl.resrvSts',
            null
          )
          this.getStatusOrder()
          this.rpsntFamilyNmKana = _.get(
            response,
            'orderStayDetail.acptDtlList[0].stayResrvRpsntInfo.rpsntFamilyNmKana',
            ''
          )
          this.rpsntFirstNmKana = _.get(
            response,
            'orderStayDetail.acptDtlList[0].stayResrvRpsntInfo.rpsntFirstNmKana',
            ''
          )
          if (this.rpsntFamilyNmKana && this.rpsntFirstNmKana) {
            this.fullName = this.rpsntFamilyNmKana + this.rpsntFirstNmKana
          } else {
            this.resrvFamilyNmKana = _.get(
              response,
              'orderStayDetail.acptDtlList[0].stayResrvRpsntInfo.resrvFamilyNmKana',
              ''
            )
            this.resrvFirstNmKana = _.get(
              response,
              'orderStayDetail.acptDtlList[0].stayResrvRpsntInfo.resrvFirstNmKana',
              ''
            )
            this.fullName = this.resrvFamilyNmKana + this.resrvFirstNmKana
          }
          this.roomCount = _.get(
            response,
            'orderStayDetail.acptDtlList[0].acptPrticList[0].stayRoomDayPrticList.length',
            ''
          )
          this.totalAmt = _.get(response, 'orderStayDetail.acpt.totalAmt', '')
          this.sbsidTotal = _.get(response, 'orderStayDetail.acpt.aplySbsidAmt', '')
          this.boneSbsidChrgTotal = _.get(
            response,
            'orderStayDetail.acptDtlList[0].dtlChrgTotal.boneSbsidChrgTotal',
            ''
          )
          this.pointUse = _.get(response, 'orderStayDetail.acpt.pointUseNumAmt', '')
          // this.billAmtTotal = _.get(response, 'orderStayDetail.acpt.billAmtTotal', '')
          this.billAmtTotal = _.get(response, 'orderStayDetail.acpt.billAmtTotal', '')
          this.dataOrderDetail = response
          this.acptDtlNo = _.get(
            response,
            'orderStayDetail.acptDtlList[0].acptDtl.acptDtlNo'
          )
          const acptTm = _.get(response, 'orderStayDetail.acpt.acptDatetime', null)
          if (acptTm !== null && acptTm !== '') {
            this.acptDatetime = moment(acptTm).format('YYYY/MM/DD')
          }
          this.pointGrntNumAmt = _.get(
            response,
            'orderStayDetail.acpt.pointGrntNumAmt',
            null
          )
          this.planNm = _.get(
            response,
            'orderStayDetail.acptDtlList[0].planBasicInfo.planNm',
            ''
          )
          const params = {
            menuNo: this.menuNo,
            companyCd: this.$route.query.companyCd
          }
          this.$store.dispatch(GET_MENU_INFO, params).then((res) => {
            if (res !== null) {
              this.menuInfo = res
              this.facilityTelNo = _.get(
                this.menuInfo,
                'facilities.facilities[0].facilityTelNo',
                ''
              )
            }
          })
          this.getPlanDetail()
        }
        this.getOrderBasicInfo()
      })
    },
    getCancelAmt() {
      const memberChrgTotal = _.get(
        this.orderDetail,
        'orderStayDetail.acptDtlList[0].dtlChrgTotal.memberChrgTotal',
        ''
      )
      this.$repositories('order')
        .getCanclePolicy(this.acptNo)
        .then(
          (response) => {
            if (response) {
              this.nightCnt = _.get(
                this.orderDetail,
                'orderStayDetail.acptDtlList[0].stayAcptDtl.nightCnt',
                1
              )
              const dateDiff =
                moment(
                  _.get(
                    this.orderDetail,
                    'orderStayDetail.acptDtlList[0].acptDtl.useDate',
                    ''
                  )
                ).diff(moment(), 'days') + 1
              const stayPlanCancelPrticList = _.get(
                response,
                'stayPlanCancelList[0].stayPlanCancelPrticList',
                null
              )
              if (stayPlanCancelPrticList) {
                let flag = 0
                for (let index = 0; index < stayPlanCancelPrticList.length; index++) {
                  const element = stayPlanCancelPrticList[index]
                  const dayEnd = _.get(element, 'cancelPolicyEndDay', 0)
                  const dayBegin = _.get(element, 'cancelPolicySttDay', 0)
                  if (dateDiff >= +dayEnd && dateDiff <= dayBegin) {
                    const noneContactFlag = _.get(element, 'noneContactFlag', null)
                    if (+noneContactFlag === 0) {
                      flag = flag + 1
                      this.cancelChrgRate = +_.get(element, 'cancelChargeRate', 0)
                      this.cancelCharge = +_.get(element, 'cancelCharge', null)
                    }
                  }
                  if (flag > 0) {
                    break
                  }
                }
              }
              if (+this.cancelCharge > 0) {
                this.cancelChrgRate = 0
              }
              this.cancelAmt =
                (memberChrgTotal * this.cancelChrgRate) / 100
                  ? (memberChrgTotal * this.cancelChrgRate) / 100
                  : this.cancelCharge
                  ? this.cancelCharge
                  : 0
            }
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
    },
    getPlanDetail() {
      this.$repositories('plan')
        .getPlanDetail(this.menuNo, this.planId, this.roomId)
        .then((data) => {
          this.planDetail = data
          this.cancelPolicy = this.planDetail.cancelPolicy
          this.menuNm = _.get(data, 'menuInformation.menuNm', '')
          this.dataItem = {
            type: 'type-small',
            menu_id: _.get(data, 'menuInformation.menuNo', ''),
            label: _.get(data, 'menuInformation.categoryInfomation', ''),
            baseImg: _.get(data, 'roomBasicInfo.roomImages', ''),
            title3: _.get(data, 'menuInformation.menuNm', ''),
            phone: this.facilityTelNo,
            pointGrntNumAmt: this.pointGrntNumAmt
          }
          this.cancelPolicies = this.cancelPolicy.cancelPolicies
        })
    },
    getPlanBasicInfo() {
      this.planBasicInfo = this.getPlanInfo ? this.getPlanInfo.planBasicInfo : null
      this.roomBasicInfo = this.getPlanInfo ? this.getPlanInfo.roomBasicInfo : null
    },
    showConfirm() {
      const context = this
      this.$confirm({
        title: 'オーダーをキャンセルします。よろしいでしょうか。',
        content: '',
        onOk() {
          context.handleCancelOrder()
          return new Promise((resolve, reject) => {
            setTimeout(Math.random() > 0.5 ? resolve : reject, 1000)
          }).catch(() => console.log(''))
        },
        onCancel() {}
      })
    },
    getStatusOrder() {
      const today = moment().format('YYYY/MM/DD')
      if (today < this.useDate) {
        this.statusOrder = '利用前'
      }
      if (today > this.endDate) {
        this.statusOrder = '利用済み'
      }
      if (today >= this.useDate && today <= this.endDate) {
        this.statusOrder = '利用中'
      }
    },
    handleCancelOrder() {
      const orderInfo = this.orderDetail
      const bs_myp_05_040 = {
        acptNo: this.acptNo,
        acptDtlNo: this.acptDtlNo,
        acptDatetime: this.acptDatetime,
        planNm: this.planNm,
        roomCount: this.roomCount,
        // totalAmt: this.totalAmt,
        sbsidTotal: this.sbsidTotal,
        boneSbsidChrgTotal: this.boneSbsidChrgTotal,
        pointUse: this.pointUse,
        // billAmtTotal: this.billAmtTotal,
        useDate: this.useDate,
        endDate: this.endDate,
        fullName: this.fullName,
        dataItem: this.dataItem,
        reserveSts: this.reserveSts,
        statusOrder: this.statusOrder,
        menuNm: this.menuNm,
        cancelPolicy: this.cancelPolicy,
        totalAmt: _.get(orderInfo, 'orderStayDetail.acpt.totalAmt', null),
        billAmtTotal: _.get(orderInfo, 'orderStayDetail.acpt.billAmtTotal', null),
        boneBillAmtTotal: _.get(orderInfo, 'orderStayDetail.acpt.boneBillAmtTotal', null),
        setlSts: _.get(orderInfo, 'orderStayDetail.acpt.setlSts', null),
        // acptDtlNo: _.get(orderInfo, 'orderStayDetail.acptDtlList[0].acptDtl.acptDtlNo', null),
        acptPrticNo: _.get(orderInfo, ''),
        orderDetail: this.orderDetail
      }
      this.$store.dispatch(SAVE_DATA_BS_MYP_05_040, bs_myp_05_040).then(() => {})
      const query = this.$route.query
      this.$router.push({ path: '/mypage/cancel-confirmation-payment', query })
    },
    handleNext() {
      if (this.confirmCheckbox) {
        this.checkFeeCancel()
      } else {
        this.$toasted.error(this.errorMessageNext)
      }
    },
    handleBack() {
      const query = this.$route.query
      const menuNo = this.$route.query.menuNo
      this.$router.push({ path: `/mypage/orders/${menuNo}`, query })
    },
    // ---------------------------->Chuyen 05-041 sang
    getOrderInfoData() {
      const orderInfo = this.orderDetail
      const dataOrder = {
        acptNo: this.acptNo,
        acptDtlNo: this.acptDtlNo,
        acptDatetime: this.acptDatetime,
        planNm: this.planNm,
        roomCount: this.roomCount,
        // totalAmt: this.totalAmt,
        sbsidTotal: this.sbsidTotal,
        boneSbsidChrgTotal: this.boneSbsidChrgTotal,
        pointUse: this.pointUse,
        // billAmtTotal: this.billAmtTotal,
        useDate: this.useDate,
        endDate: this.endDate,
        fullName: this.fullName,
        dataItem: this.dataItem,
        reserveSts: this.reserveSts,
        statusOrder: this.statusOrder,
        menuNm: this.menuNm,
        cancelPolicy: this.cancelPolicy,
        totalAmt: _.get(orderInfo, 'orderStayDetail.acpt.totalAmt', null),
        billAmtTotal: _.get(orderInfo, 'orderStayDetail.acpt.billAmtTotal', null),
        boneBillAmtTotal: _.get(orderInfo, 'orderStayDetail.acpt.boneBillAmtTotal', null),
        setlSts: _.get(orderInfo, 'orderStayDetail.acpt.setlSts', null),
        // acptDtlNo: _.get(orderInfo, 'orderStayDetail.acptDtlList[0].acptDtl.acptDtlNo', null),
        acptPrticNo: _.get(orderInfo, ''),
        orderDetail: this.orderDetail
      }
      return dataOrder
    },
    getOrderBasicInfo() {
      const data = this.getOrderInfoData()
      if (data !== null) {
        // this.orderDetail = _.get(data, 'orderDetail', '')
        this.acptDatetime = _.get(data, 'acptDatetime', '')
        this.acptNo = _.get(data, 'acptNo', '')
        this.acptDtlNo = _.get(data, 'acptDtlNo', '')
        this.dataItem = _.get(data, 'dataItem', '')
        this.planNm = _.get(data, 'planNm', '')
        this.roomCount = _.get(data, 'roomCount', '')
        this.useDate = _.get(data, 'useDate', '')
        this.endDate = _.get(data, 'endDate', '')
        this.fullName = _.get(data, 'fullName', '')
        this.reserveSts = _.get(data, 'reserveSts', '')
        this.statusOrder = _.get(data, 'statusOrder', '')
        this.menuNm = _.get(data, 'menuNm', '')
        this.memberChrgTotal = _.get(
          this.orderDetail,
          'orderStayDetail.acptDtlList[0].dtlChrgTotal.memberChrgTotal',
          ''
        )
        this.tieupChrgTotal = _.get(
          this.orderDetail,
          'orderStayDetail.acptDtlList[0].dtlChrgTotal.tieupChrgTotal',
          ''
        )
        this.boneSbsidChrgTotal = _.get(
          this.orderDetail,
          'orderStayDetail.acptDtlList[0].dtlChrgTotal.boneSbsidChrgTotal',
          ''
        )
        this.billAmtTotal = _.get(data, 'billAmtTotal', '')
        this.$repositories('order')
          .getCanclePolicy(this.acptNo)
          .then(
            (response) => {
              if (response) {
                this.cancelPolicy = response
                this.nightCnt = _.get(
                  this.orderDetail,
                  'orderStayDetail.acptDtlList[0].stayAcptDtl.nightCnt',
                  1
                )
                // const useDate = moment(_.get(this.orderDetail, 'orderStayDetail.acptDtlList[0].acptDtl.useDate', '')).format('DD')
                // const currDate = moment().format('DD')
                // const aboutDayEnd = _.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[0].cancelPolicyEndDay', 0)
                // const aboutDayBegin = _.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[0].cancelPolicySttDay', 0)
                // if((useDate - currDate) >= +aboutDayEnd && (useDate - currDate) <= +aboutDayBegin) {
                //   const noneContactFlag =  _.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[0].noneContactFlag', 0)
                //   if(noneContactFlag === '0') {
                //     this.cancelChrgRate = +(_.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[0].cancelChargeRate', 0))
                //     this.cancelChrDiv = +(_.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[0].cancelChargeDiv', null))
                //   }
                //   this.stayPlanCancelPrticKey = _.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[0].stayPlanCancelPrticKey', '')
                //   this.cancelCharge = +(_.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[0].cancelCharge', null))
                // } else if ((useDate - currDate) === 0) {
                //   const noneContactFlag1 = _.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[1].noneContactFlag', 0)
                //   if(noneContactFlag1 === '0') {
                //     this.cancelChrgRate = +(_.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[1].cancelChargeRate', 0))
                //     this.cancelChrDiv = +(_.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[1].cancelChargeDiv', null))
                //   }
                //   this.stayPlanCancelPrticKey = _.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[1].stayPlanCancelPrticKey', '')
                //   this.cancelCharge = +(_.get(response, 'stayPlanCancelList[0].stayPlanCancelPrticList[1].cancelCharge', null))
                // }
                const dateDiff =
                  moment(
                    _.get(
                      this.orderDetail,
                      'orderStayDetail.acptDtlList[0].acptDtl.useDate',
                      ''
                    )
                  ).diff(moment(), 'days') + 1
                const stayPlanCancelPrticList = _.get(
                  response,
                  'stayPlanCancelList[0].stayPlanCancelPrticList',
                  null
                )
                if (stayPlanCancelPrticList) {
                  let flag = 0
                  for (let index = 0; index < stayPlanCancelPrticList.length; index++) {
                    const element = stayPlanCancelPrticList[index]
                    const dayEnd = _.get(element, 'cancelPolicyEndDay', 0)
                    const dayBegin = _.get(element, 'cancelPolicySttDay', 0)

                    if (dateDiff >= +dayEnd && dateDiff <= dayBegin) {
                      const noneContactFlag = _.get(element, 'noneContactFlag', null)
                      if (+noneContactFlag === 0) {
                        flag = flag + 1
                        this.cancelChrgRate = +_.get(element, 'cancelChargeRate', 0)
                        this.cancelCharge = +_.get(element, 'cancelCharge', null)
                        this.cancelChrDiv = +_.get(element, 'cancelChargeDiv', null)
                        this.stayPlanCancelPrticKey = _.get(
                          element,
                          'stayPlanCancelPrticKey',
                          ''
                        )
                      }
                    }
                    if (flag > 0) {
                      break
                    }
                  }
                }
                if (+this.cancelCharge > 0) {
                  this.useHeadCnt = +_.get(
                    this.orderDetail,
                    'orderStayDetail.acptDtlList[0].acptDtl.useHeadCnt',
                    1
                  )
                  this.cancelChrgUnit = +(
                    this.cancelCharge /
                    this.useHeadCnt /
                    this.nightCnt
                  )
                  this.cancelChrgRate = 0
                }
                this.cancelAmt =
                  (this.memberChrgTotal * this.cancelChrgRate) / 100
                    ? (this.memberChrgTotal * this.cancelChrgRate) / 100
                    : this.cancelCharge
                    ? this.cancelCharge
                    : 0
              }
              this.getInfoChrgRoom(_.get(data, 'orderDetail', ''))
            },
            (error) => {
              this.$toasted.error(error?.message)
            }
          )
      }
    },

    checkFeeCancel() {
      const orderInfo = this.getOrderInfoData()
      const orderDetail = this.orderDetail
      const cancelPolicy = this.cancelPolicy
      // const useDate = moment(_.get(orderDetail, 'orderStayDetail.acptDtlList[0].acptDtl.useDate', ''))
      // const curDate = moment()
      // console.log('testDiff', moment(_.get(orderDetail, 'orderStayDetail.acptDtlList[0].acptDtl.useDate', '')).diff(moment(new Date()), 'days'))
      const dateDiff =
        moment(
          _.get(orderDetail, 'orderStayDetail.acptDtlList[0].acptDtl.useDate', '')
        ).diff(moment(), 'days') + 1
      const data = {
        totalAmt: _.get(orderInfo, 'totalAmt', null),
        billAmtTotal: _.get(orderInfo, 'billAmtTotal', null),
        boneBillAmtTotal: _.get(orderInfo, 'boneBillAmtTotal', null),
        setlSts: _.get(orderInfo, 'setlSts', null),
        rciptReqrdFlag: null,
        rciptAddrNm: null,
        acptRomDtl: {
          romSchAmt:
            (this.memberChrgTotal * this.cancelChrgRate) / 100
              ? (this.memberChrgTotal * this.cancelChrgRate) / 100
              : this.cancelCharge
              ? this.cancelCharge
              : 0,
          payMethod: this.payMethod,
          creditCardExpirYm: null,
          romSts: '1',
          setlSystem: null,
          setlTrnId: null
        },
        acptDtlDomesticStayCancelList: [
          {
            dtlChrgTotal: {
              acptDtlNo: _.get(
                orderDetail,
                'orderStayDetail.acptDtlList[0].acptDtl.acptDtlNo',
                ''
              ),
              cancelAmt:
                (this.memberChrgTotal * this.cancelChrgRate) / 100
                  ? (this.memberChrgTotal * this.cancelChrgRate) / 100
                  : this.cancelCharge
                  ? this.cancelCharge
                  : 0,
              tieupCancelAmt:
                (this.tieupChrgTotal * this.cancelChrgRate) / 100
                  ? (this.tieupChrgTotal * this.cancelChrgRate) / 100
                  : this.cancelCharge
                  ? this.cancelCharge
                  : 0,
              cancelSbsidTotal:
                (this.boneSbsidChrgTotal * this.cancelChrgRate) / 100
                  ? (this.boneSbsidChrgTotal * this.cancelChrgRate) / 100
                  : '0'
            },
            ccCancelPolicyList: [
              {
                stayPlanCancelPrticKey: this.stayPlanCancelPrticKey,
                cancelPolicyDays: dateDiff,
                cancelChrgOccurDate: moment().format('YYYY-MM-DD'),
                cancelChrgDiv: _.get(
                  cancelPolicy,
                  'stayPlanCancelList[0].stayPlanCancelPrticList[0].cancelChargeDiv',
                  null
                ),
                cancelChargeBaseValue:
                  +this.cancelChrDiv === 0
                    ? this.cancelChrgRate
                    : +this.cancelChrDiv === 1
                    ? this.cancelCharge
                    : null,
                stayCancelAcptPrticList: this.stayCancelAcptPrticList
              }
            ]
          }
        ]
      }
      data.acptNo = this.acptNo
      this.$store.commit('order/setOrderCancel', data)
      if (this.cancelAmt > 0) {
        this.handlePayment()
      } else {
        this.handleCancelOrder1(data)
      }
    },
    handlePayment() {
      this.$repositories('plan')
        .putPay({
          menuNm: this.menuNm,
          billingAmount: this.cancelAmt
        })
        .then(
          (response) => {
            if (response) {
              if (process.env.NODE_ENV !== this.CONST_DATA.ENV.LOCAL) {
                location.href = `${process.env.VUE_APP_URL_PAYMENT_GATEWAY}${response}`
              } else {
                this.$router.push({
                  path: '/mypage/cancel-confirmation-payment/loading',
                  query: {
                    param:
                      '1G26a0BWFO0mug0e82DeCW74TUzQquDhSYY7v7ha6Nl%2FLeFDxSFiMqjQ8I4J%2F%2BsYvB5V92jFkpMuqGp0z42NN9IzQQe86Jq4FRU1a9ebQuo8Tza0k0KSxyK7TUXliFEtxQoPqxObpWzvUxuBYxvuM3ofP%2FO47Q5IszsSs%2FJ%2FIYGQsXRM1YcxdlG26TDNOamxtUyQmMLGJbmtpnavcosnFNeMK%2F%2BpDgjJZD6TMfqiqJZk9d%2FzEA%2FrHEy94nT46dPEpRALW2sTMpDPed5ytcextw%3D%3D'
                  }
                })
              }
            }
          },
          /* eslint-disable no-unused-vars */
          (error) => {
            this.$toasted.error('エラーが発生しました')
          }
        )
    },
    handleCancelOrder1(data) {
      this.$store.dispatch(CANCEL_ORDER, data).then(
        (response) => {
          const cancelNo = response.cancelNo[0]
          this.$store.dispatch(SAVE_CANCEL_NO, cancelNo)
          this.$toasted.success('オーダーがキャンセルされました。')
          const query = this.$route.query
          this.$router.push({ path: '/mypage/cancel-complete', query })
        },
        (err) => {
          const error = err.error
          this.$toasted.error(error && error.message ? error.message : error)
        }
      )
    },
    getInfoChrgRoom(data) {
      this.stayCancelAcptPrticList = []

      const useAgeDiv = _.get(data, 'orderStayDetail.acptDtlList[0].acptDtl.usageDiv', '')
      const acptPrticList = _.get(
        data,
        'orderStayDetail.acptDtlList[0].acptPrticList',
        ''
      )
      if (acptPrticList) {
        acptPrticList.forEach((ele1) => {
          const acptPrticNoEle = _.get(ele1, 'acptPrtic.acptPrticNo', '')
          const aloctRoomEle = _.get(ele1, 'stayPrtic.aloctRoom', '')
          const roomIdEle = _.get(ele1, 'stayPrtic.roomId', '')
          const stayRoomDayPrticList = _.get(ele1, 'stayRoomDayPrticList', '')
          if (stayRoomDayPrticList) {
            stayRoomDayPrticList.forEach((ele2) => {
              const stayRoomDayPrtic = _.get(ele2, 'stayRoomDayPrtic', '')
              let chrgTotal = {}
              if (stayRoomDayPrtic) {
                const memberChrgChildTotal =
                  _.get(stayRoomDayPrtic, 'chldaMemberChrgSubtl', null) +
                  _.get(stayRoomDayPrtic, 'chldbMemberChrgSubtl', null) +
                  _.get(stayRoomDayPrtic, 'chldcMemberChrgSubtl', null) +
                  _.get(stayRoomDayPrtic, 'chlddMemberChrgSubtl', null) +
                  _.get(stayRoomDayPrtic, 'chldeMemberChrgSubtl', null) +
                  _.get(stayRoomDayPrtic, 'chldfMemberChrgSubtl', null)
                const boneSbsidChrgChildTotal =
                  _.get(stayRoomDayPrtic, 'chldaBoneSbsidChrgSubtl', null) +
                  _.get(stayRoomDayPrtic, 'chldbBoneSbsidChrgSubtl', null) +
                  _.get(stayRoomDayPrtic, 'chldcBoneSbsidChrgSubtl', null) +
                  _.get(stayRoomDayPrtic, 'chlddBoneSbsidChrgSubtl', null) +
                  _.get(stayRoomDayPrtic, 'chldeBoneSbsidChrgSubtl', null) +
                  _.get(stayRoomDayPrtic, 'chldfBoneSbsidChrgSubtl', null)
                let memberChrgTotal =
                  _.get(stayRoomDayPrtic, 'adultMemberChrgSubtl', null) +
                  memberChrgChildTotal
                if (!memberChrgTotal) {
                  memberChrgTotal = _.get(stayRoomDayPrtic, 'roomMemberChrgSubtl', 0)
                }
                let boneSbsidChrgTotal =
                  _.get(stayRoomDayPrtic, 'adultBoneSbsidChrgSubtl', 0) +
                  boneSbsidChrgChildTotal
                if (!boneSbsidChrgTotal) {
                  boneSbsidChrgTotal = _.get(
                    stayRoomDayPrtic,
                    'roomBoneSbsidChrgSubtl',
                    0
                  )
                }
                const tieupChrgTotal = +memberChrgTotal + boneSbsidChrgTotal
                const headCnt =
                  +_.get(stayRoomDayPrtic, 'adultTotalHeadCnt', 0) +
                  _.get(stayRoomDayPrtic, 'vistrAdultTotalHeadCnt', 0) +
                  _.get(stayRoomDayPrtic, 'chldHeadCnt', 0) +
                  _.get(stayRoomDayPrtic, 'vistrChldHeadCnt', 0)

                const cancelChrgUnitT =
                  (+memberChrgTotal * this.cancelChrgRate) / 100 / headCnt
                const cancelChrgSubtlT = (+memberChrgTotal * this.cancelChrgRate) / 100
                const cancelSbsidT =
                  (+tieupChrgTotal * this.cancelChrgRate) / 100 -
                  (+memberChrgTotal * this.cancelChrgRate) / 100
                const tieupCancelChrgUniT =
                  (+tieupChrgTotal * this.cancelChrgRate) / 100 / headCnt
                const tieupCancelChrgSubtl = (+tieupChrgTotal * this.cancelChrgRate) / 100

                chrgTotal = {
                  acptPrticNo: acptPrticNoEle,
                  aloctRoom: aloctRoomEle,
                  roomId: roomIdEle,
                  stayDay: _.get(stayRoomDayPrtic, 'stayDay', ''),
                  ageDiv: useAgeDiv,
                  vistrFlag: _.get(stayRoomDayPrtic, 'vistrFlag', ''),
                  cancelHeadCnt: headCnt,
                  cancelChrgUnit: cancelChrgUnitT ? cancelChrgUnitT : this.cancelChrgUnit,
                  cancelChrgSubtl: cancelChrgSubtlT
                    ? cancelChrgSubtlT
                    : this.cancelChrgUnit * headCnt,
                  cancelSbsid: cancelSbsidT ? cancelSbsidT : 0,
                  tieupCancelChrgUnit: tieupCancelChrgUniT
                    ? tieupCancelChrgUniT
                    : this.cancelChrgUnit,
                  tieupCancelChrgSubtl: tieupCancelChrgSubtl
                    ? tieupCancelChrgSubtl
                    : this.cancelChrgUnit * headCnt
                }
              }
              this.stayCancelAcptPrticList.push(chrgTotal)
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

table,
th,
td {
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
}

.nav {
  width: 100%;
}
</style>
